/**
 * @generated SignedSource<<12e64d43a91d61e2683a46c11cf0aa8f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type MarketoUpdateSettingsInput = {
  clientId?: string | null | undefined;
  clientMutationId?: string | null | undefined;
  clientSecret?: string | null | undefined;
  formsEnabled?: boolean | null | undefined;
  hasClientSecret?: boolean | null | undefined;
  marketoApiActive?: boolean | null | undefined;
  munchkinId?: string | null | undefined;
  setClientSecret?: string | null | undefined;
  staticListIds?: ReadonlyArray<string | null | undefined> | null | undefined;
};
export type Integration_MarketoUpdateSettings_Mutation$variables = {
  input: MarketoUpdateSettingsInput;
};
export type Integration_MarketoUpdateSettings_Mutation$data = {
  readonly marketoUpdateSettings: {
    readonly settings: {
      readonly clientId: string | null | undefined;
      readonly clientSecret: string | null | undefined;
      readonly formsEnabled: boolean | null | undefined;
      readonly hasClientSecret: boolean | null | undefined;
      readonly marketoApiActive: boolean | null | undefined;
      readonly munchkinId: string | null | undefined;
      readonly staticListIds: ReadonlyArray<string | null | undefined> | null | undefined;
    } | null | undefined;
  } | null | undefined;
};
export type Integration_MarketoUpdateSettings_Mutation = {
  response: Integration_MarketoUpdateSettings_Mutation$data;
  variables: Integration_MarketoUpdateSettings_Mutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "MarketoUpdateSettingsPayload",
    "kind": "LinkedField",
    "name": "marketoUpdateSettings",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "MarketoSettings",
        "kind": "LinkedField",
        "name": "settings",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "marketoApiActive",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "munchkinId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "clientId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "clientSecret",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "hasClientSecret",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "formsEnabled",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "staticListIds",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "Integration_MarketoUpdateSettings_Mutation",
    "selections": (v1/*: any*/),
    "type": "RootMutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "Integration_MarketoUpdateSettings_Mutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "032b50da0cc869f94f355605d42b724e",
    "id": null,
    "metadata": {},
    "name": "Integration_MarketoUpdateSettings_Mutation",
    "operationKind": "mutation",
    "text": "mutation Integration_MarketoUpdateSettings_Mutation(\n  $input: MarketoUpdateSettingsInput!\n) {\n  marketoUpdateSettings(input: $input) {\n    settings {\n      marketoApiActive\n      munchkinId\n      clientId\n      clientSecret\n      hasClientSecret\n      formsEnabled\n      staticListIds\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "f87744433e212038c9a81ad3f1c7e262";

export default node;
